import { extraSmall } from './sizes/extraSmall';
import { small } from './sizes/small';
import { medium } from './sizes/medium';
import { large } from './sizes/large';
import { megaLarge } from './sizes/megaLarge';
import { custom } from './sizes/custom';

const inputStyleFactory = (size, obj) => {
  switch (size) {
    case 'extraSmall':
    case 'xs':
      return extraSmall();
    case 'small':
    case 'sm':
      return small();
    case 'medium':
    case 'md':
      return medium();
    case 'large':
    case 'lg':
      return large();
    case 'megaLarge':
    case 'xl':
      return megaLarge();
    case 'custom':
      return custom(obj);
    default:
      return medium();
  }
};

export { inputStyleFactory };
